import React from "react";
import { SidebarInfo } from "../../components/SidebarInfo";
import animation from "../../layout/OnboardingLayout.module.scss";

export const PaymentProcessorSidebar: React.FC = () => (
    <aside>
        <SidebarInfo className={animation.fadeIn2}>
            <header>Why do you need access to my payment processor?</header>

            <p>
                Connecting your payment processor helps Kick maintain accurate
                financials by categorizing revenue and fees in real-time.
            </p>
        </SidebarInfo>

        <SidebarInfo className={animation.fadeIn1}>
            <header>Don’t have a payment processor?</header>

            <p>
                We recommend using <strong>Stripe</strong> or{" "}
                <strong>PayPal</strong> to accept payments.
            </p>

            <p>
                Our direct integrations sync product and customer information,
                break out revenue and fees, and ensure accurate categorization
                of loans and transfers.{" "}
            </p>
        </SidebarInfo>
    </aside>
);
